// A TELA QUE DESLIZA, COMO NUM APLICATIVO (06/10/2026).
//
// Missão PWA do Victor: no celular o advup tem que se comportar como app. Num
// app, entrar num detalhe (uma conversa, uma ficha) faz a tela nova DESLIZAR
// da direita por cima da anterior; voltar desliza de volta. Trocar de aba na
// barra de baixo é instantâneo. Sem isso, toda troca de tela é um corte seco
// — a sensação de "site".
//
// Feito com a View Transitions API do navegador (Chrome/Android, Safari 18+):
// ele fotografa a tela velha, a rota troca, e o CSS anima uma sobre a outra
// (ver `_advup-app.scss`). Onde a API não existe, nada muda. Só no celular
// (< 768px) e nunca com "reduzir movimento" ligado.

// Quantas "camadas" o endereço tem: `/app/accounts/1/processos/27` → 5.
const profundidade = rota =>
  (rota?.path || '').split('/').filter(Boolean).length;

// avanca: entrou num detalhe · volta: saiu dele · null: sem animação
export const tipoDaTransicao = (para, de, movimentoDaHistoria = 0) => {
  if (!de?.name || !para?.name) return null;
  if (movimentoDaHistoria < 0) return 'volta';
  if (movimentoDaHistoria > 0) return 'avanca';
  // a mesma tela com outro parâmetro (outra conversa, outra aba) não desliza
  if (para.name === de.name) return null;
  const diferenca = profundidade(para) - profundidade(de);
  if (diferenca > 0) return 'avanca';
  if (diferenca < 0) return 'volta';
  return null;
};

const podeAnimar = () =>
  typeof document !== 'undefined' &&
  typeof document.startViewTransition === 'function' &&
  !document.hidden &&
  window.innerWidth < 768 &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const ligarTransicoesDeTela = (router, esperarDesenho) => {
  // A posição da entrada atual na história (o vue-router grava `position` em
  // `history.state`). Se, ao começar a navegação, a posição já mudou, foi o
  // Voltar/Avançar do navegador (ou o gesto de voltar do celular).
  let posicaoAtual = window.history.state?.position ?? 0;
  let terminar = null;

  router.beforeResolve((para, de) => {
    if (!podeAnimar()) return true;
    const agora = window.history.state?.position ?? posicaoAtual;
    const tipo = tipoDaTransicao(para, de, Math.sign(agora - posicaoAtual));
    if (!tipo) return true;

    document.documentElement.dataset.transicao = tipo;
    return new Promise(seguir => {
      const transicao = document.startViewTransition(
        () =>
          new Promise(pronto => {
            terminar = pronto;
            seguir(true);
          })
      );
      transicao.finished.finally(() => {
        delete document.documentElement.dataset.transicao;
      });
    });
  });

  // Sempre roda, inclusive quando a navegação falha: a transição nunca fica
  // presa esperando uma tela que não vem.
  router.afterEach(async () => {
    posicaoAtual = window.history.state?.position ?? posicaoAtual;
    if (!terminar) return;
    const pronto = terminar;
    terminar = null;
    await esperarDesenho();
    pronto();
  });
};
